import { UserRole } from '@p2p/users/domain';

export interface Account {
    id: number;
    role: UserRole;
    email: string;
    username: string;
}
